import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges
} from '@angular/core';
import { NzSafeAny } from 'ng-zorro-antd/core/types';
import tinycolor from 'tinycolor2';
import { IRgb } from './color-picker.type';

@Component({
  selector: 'bixi-color-fields',
  exportAs: 'bixiColorFields',
  host: { '[class.bixi-color-fields]': 'true' },
  template: `
  <div class="bixi-color-fields-hex">
    <div class="bixi-color-field">
      <div class="bixi-color-field-input">
        <nz-input-group nzPrefix="#" nzSize="small">
          <input type="text" nz-input  [(ngModel)]="_hex" maxlength='6' (ngModelChange)="onHexChange()"/>
        </nz-input-group>
      </div>
      <div class="bixi-color-field-title">
        HEX
      </div>
    </div>
  </div>
  <div class="bixi-color-fields-rgba">
    <div class="bixi-color-field">
      <div class="bixi-color-field-input">
        <input type="text" nz-input  nzSize="small" maxlength='3' [(ngModel)]="_rgb.r"  (ngModelChange)="onRgbChange()"/>
      </div>
      <div class="bixi-color-field-title">
        R
      </div>
    </div>
    <div class="bixi-color-field">
      <div class="bixi-color-field-input">
        <input type="text" nz-input  nzSize="small" maxlength='3' [(ngModel)]="_rgb.g" (ngModelChange)="onRgbChange()"/>
      </div>
      <div class="bixi-color-field-title">
        G
      </div>
    </div>
    <div class="bixi-color-field">
      <div class="bixi-color-field-input">
        <input type="text" nz-input  nzSize="small" maxlength='3' [(ngModel)]="_rgb.b" (ngModelChange)="onRgbChange()"/>
      </div>
      <div class="bixi-color-field-title">
        B
      </div>
    </div>
    <div class="bixi-color-field bixi-color-field-alpha" *ngIf="!hideAlpha">
      <div class="bixi-color-field-input">
        <input type="text"  nz-input  nzSize="small" maxlength='3' [(ngModel)]="_rgb.a" (ngModelChange)="onRgbChange()"/>
      </div>
      <div class="bixi-color-field-title">
        A
      </div>
    </div>
  </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BixiColorFieldsComponent implements OnChanges {
  _hex: string;
  _rgb: IRgb;
  @Input() hex = '';
  @Input() rgb: IRgb;
  @Input() hideAlpha = false;
  @Output() colorChange = new EventEmitter<IRgb | string>();

  ngOnChanges(chanees: SimpleChanges) {
    const { hex, rgb } = chanees;

    if (hex) {
      const val = hex.currentValue;
      if (!tinycolor.equals(this._hex, val)) {
        this._hex = val.startsWith('#') ? val.substring(1) : val;
      }
    }
    if (rgb) {
      const val = rgb.currentValue || {};
      this._rgb = {
        ...val,
        a: (val.a * 100)
      };
    }
  }

  parseInt(str: NzSafeAny, defaultRes = 0) {
    try {
      return parseInt(str, 10);
    } catch (e) {
      return defaultRes;
    }
  }

  onHexChange() {
    if (tinycolor(this._hex).isValid()) {
      this.colorChange.emit(this._hex);
    }
  }

  onRgbChange() {
    const color: IRgb = {
      r: this.parseInt(this._rgb.r),
      g: this.parseInt(this._rgb.g),
      b: this.parseInt(this._rgb.b),
      a: this.parseInt(this._rgb.a) / 100
    };
    if (tinycolor(color).isValid()) {
      this.colorChange.emit(color);
    }
  }
}
